var _circle, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoodGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sad-emoji",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_584",
    "data-name": "Ellipse 584",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#d1d1cf"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10515",
    "data-name": "Path 10515",
    d: "M21.329,11.329A10,10,0,0,1,3.545,17.608,10,10,0,0,0,17.608,3.545,9.989,9.989,0,0,1,21.329,11.329Z",
    transform: "translate(-1.329 -1.329)",
    fill: "#d1d1cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10531",
    "data-name": "Path 10531",
    d: "M16.941,22.4a.678.678,0,0,1-.681.675,6.147,6.147,0,0,1-2.323.5,9.73,9.73,0,0,1-2.69-.5.678.678,0,1,1,0-1.356,9.779,9.779,0,0,0,2.694.5,6.111,6.111,0,0,0,2.318-.5A.683.683,0,0,1,16.941,22.4Z",
    transform: "translate(-3.902 -7.454)",
    fill: "#3e4347"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16935",
    "data-name": "Group 16935",
    transform: "translate(3.335 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10510",
    "data-name": "Path 10510",
    d: "M11.27,9.467C11,14.113,9.805,13.656,7.995,13.656c-1.669,0-2.916-1.876-2.781-4.189s1.6-4.189,3.269-4.189S11.4,7.154,11.27,9.467Z",
    transform: "translate(-5.204 -5.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10511",
    "data-name": "Path 10511",
    d: "M11.4,13.467a1.306,1.306,0,1,1-1.329-1.329A1.33,1.33,0,0,1,11.4,13.467Z",
    transform: "translate(-6.548 -7.85)",
    fill: "#3e4347"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_582",
    "data-name": "Ellipse 582",
    cx: 0.259,
    cy: 0.381,
    rx: 0.259,
    ry: 0.381,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 3.57, 5.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10512",
    "data-name": "Path 10512",
    d: "M17.085,9.467c.271,4.646,1.464,4.189,3.275,4.189,1.669,0,2.916-1.876,2.781-4.189s-1.6-4.189-3.269-4.189S16.951,7.154,17.085,9.467Z",
    transform: "translate(-9.655 -5.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10513",
    "data-name": "Path 10513",
    d: "M21.717,13.467a1.306,1.306,0,1,1-1.329-1.329A1.33,1.33,0,0,1,21.717,13.467Z",
    transform: "translate(-10.416 -7.85)",
    fill: "#3e4347"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_583",
    "data-name": "Ellipse 583",
    cx: 0.259,
    cy: 0.381,
    rx: 0.259,
    ry: 0.381,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 10.016, 5.035)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodGray);
export default __webpack_public_path__ + "static/media/good_gray.2226aa2942e9907c61a78eda716f2999.svg";
export { ForwardRef as ReactComponent };